import '@hotwired/turbo-rails'
import 'promise-polyfill/src/polyfill'
import 'unfetch/polyfill'
import 'core-js'
import 'regenerator-runtime/runtime'
import RelayRuntime from 'relay-runtime'
import ReactRelay from 'react-relay'
import createReactClass from 'create-react-class'
import {Idiomorph} from 'idiomorph' // eslint-disable-line import/no-extraneous-dependencies

import setupGF from '../legacy/GlassFrog/setup'

import {enableWYSIWYG, disableWYSIWYG} from '../utils/MiscUtils/wysiwygFeatureFlag'
import getCurrentLocale from '../utils/getCurrentLocale'

import Glassfrog from '../Glassfrog'
import pageFramePopstate from '../hotwire/pageFramePopstate'
import '../legacy_support/index'
import '../styles/glassfrog.scss'

const ReactDOM = require('react-dom')

// react_ujs@2.6 calls createRoot from react-dom. Set the client-entrypoint flag
// so React doesn't warn, while preserving the original react-dom implementation.
// eslint-disable-next-line no-underscore-dangle
const ReactDOMInternals = ReactDOM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
const originalCreateRoot = ReactDOM.createRoot
const originalHydrateRoot = ReactDOM.hydrateRoot

if (typeof originalCreateRoot === 'function' && ReactDOMInternals) {
  ReactDOM.createRoot = (container, options) => {
    ReactDOMInternals.usingClientEntryPoint = true
    try {
      return originalCreateRoot(container, options)
    } finally {
      ReactDOMInternals.usingClientEntryPoint = false
    }
  }
}

if (typeof originalHydrateRoot === 'function' && ReactDOMInternals) {
  ReactDOM.hydrateRoot = (container, initialChildren, options) => {
    ReactDOMInternals.usingClientEntryPoint = true
    try {
      return originalHydrateRoot(container, initialChildren, options)
    } finally {
      ReactDOMInternals.usingClientEntryPoint = false
    }
  }
}

const ReactRailsUJS = require('react_ujs')

Turbo.session.drive = true

// Expose Turbo globally for debugging and frame morphing
window.Turbo = Turbo

// We used to call `ReactRailsUJS.mountComponents(...)` on every Hotwired page.  This handles that automatically.
ReactRailsUJS.handleEvent('turbo:frame-load', ReactRailsUJS.handleMount)
ReactRailsUJS.handleEvent('turbo:frame-render', ReactRailsUJS.handleUnmount)

// Disable Turbolinks by default, and selectively enabled them with this attribute: `<a data-turbo="true">`
Turbo.session.drive = false

pageFramePopstate.setupPageFramePopstate()

setupGF()

window.Glassfrog = Glassfrog
// expose these for learning purposes
window.RelayRuntime = RelayRuntime
window.ReactRelay = ReactRelay
window.createReactClass = createReactClass
window.Idiomorph = Idiomorph

window.enableWYSIWYG = enableWYSIWYG
window.disableWYSIWYG = disableWYSIWYG

I18n.t = Glassfrog.utils.translateWithMissedKeysDetection(I18n.t)
I18n.locale = getCurrentLocale()
